module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/HowToForeground-cacd1599aefb897d3053587b478edc0b.png";